import {TargetContainerFormatterInterface} from "./TargetContainerFormatterInterface";


export class SingleTargetContainerFormatter implements TargetContainerFormatterInterface{
    public format(targetContainers: HTMLElement | Element | null): {targetContainer: HTMLElement, targetContainers: HTMLElement[]} {
        // バリデーション
        if(targetContainers === null){
            throw new Error("Target container is not found.");
        }
        if(Array.isArray(targetContainers) === true){
            throw new Error("Target container must not be array in single type.");
        }

        // nullを除外したものを戻す
        return {
            targetContainer: targetContainers as HTMLElement,
            targetContainers: [targetContainers] as HTMLElement[]
        }
    }
}